let urls = {
  local: process.env.REACT_APP_base_url_local,
  dev: process.env.REACT_APP_base_url_dev,
  prod: process.env.REACT_APP_base_url_prod
}
export const BASE_URL = urls[process.env.REACT_APP_current_stage]
